(function () {
  var storageKey = 'bloomingful:favorites';
  var wishlistEndpoint = 'https://bloomingful-back-in-stock.onrender.com/api/wishlist/items';

  function readFavorites() {
    try { return JSON.parse(window.localStorage.getItem(storageKey)) || []; } catch (error) { return []; }
  }

  function writeFavorites(favorites) {
    try { window.localStorage.setItem(storageKey, JSON.stringify(favorites)); } catch (error) {}
  }

  function updateButton(button, isSaved) {
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    button.setAttribute('aria-label', isSaved ? 'Saved to favorites' : 'Save to favorites');
    button.setAttribute('title', isSaved ? 'Saved to favorites' : 'Save to favorites');
  }

  function favoritePayload(button, action) {
    return {
      action: action,
      customer_id: button.getAttribute('data-customer-id') || '',
      customer_email: button.getAttribute('data-customer-email') || '',
      product_id: button.getAttribute('data-product-id') || '',
      variant_id: button.getAttribute('data-variant-id') || '',
      sku: button.getAttribute('data-bf-favorite-sku') || button.getAttribute('data-sku') || '',
      product_title: button.getAttribute('data-product-title') || '',
      variant_title: button.getAttribute('data-variant-title') || '',
      product_handle: button.getAttribute('data-product-handle') || '',
      product_url: button.getAttribute('data-product-url') || '',
      image_url: button.getAttribute('data-product-image') || ''
    };
  }

  function syncWishlist(button, action) {
    if (!button.getAttribute('data-customer-id')) return Promise.resolve();
    return fetch(wishlistEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(favoritePayload(button, action))
    }).then(function (response) {
      if (!response.ok) throw new Error('Wishlist sync failed');
      return response.json();
    });
  }

  function initializeButton(button) {
    if (button.getAttribute('data-bf-favorite-ready') === 'true') return;
    button.setAttribute('data-bf-favorite-ready', 'true');
    var productId = button.getAttribute('data-product-id');
    updateButton(button, readFavorites().some(function (item) { return item.id === productId; }));

    button.addEventListener('click', function () {
      var favorites = readFavorites();
      var index = favorites.findIndex(function (item) { return item.id === productId; });
      if (index >= 0) {
        var removed = favorites.splice(index, 1)[0];
        updateButton(button, false);
        syncWishlist(button, 'remove').catch(function () {
          favorites.push(removed);
          writeFavorites(favorites);
          updateButton(button, true);
        });
      } else {
        favorites.push({
          id: productId,
          title: button.getAttribute('data-product-title'),
          url: button.getAttribute('data-product-url'),
          image: button.getAttribute('data-product-image'),
          sku: button.getAttribute('data-bf-favorite-sku') || button.getAttribute('data-sku'),
          savedAt: new Date().toISOString()
        });
        updateButton(button, true);
        syncWishlist(button, 'add').catch(function () {
          writeFavorites(readFavorites().filter(function (item) { return item.id !== productId; }));
          updateButton(button, false);
        });
      }
      writeFavorites(favorites);
    });
  }

  function refreshFavorites() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-bf-favorite]'));
    if (!buttons.length) return;
    buttons.forEach(initializeButton);

    var customerId = buttons[0].getAttribute('data-customer-id');
    if (!customerId) return;
    fetch(wishlistEndpoint + '?customer_id=' + encodeURIComponent(customerId))
      .then(function (response) {
        if (!response.ok) throw new Error('Wishlist lookup failed');
        return response.json();
      })
      .then(function (payload) {
        var serverFavorites = payload.items || [];
        buttons.forEach(function (button) {
          var saved = serverFavorites.some(function (item) {
            return String(item.shopify_product_legacy_id) === String(button.getAttribute('data-product-id')) &&
              String(item.shopify_variant_legacy_id) === String(button.getAttribute('data-variant-id'));
          });
          updateButton(button, saved);
        });
      })
      .catch(function () {});
  }

  function scheduleRefresh() { window.requestAnimationFrame(refreshFavorites); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleRefresh);
  else scheduleRefresh();
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('ajaxProduct:loaded', scheduleRefresh);
  document.addEventListener('collection:rebuilt', scheduleRefresh);

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;

    document.querySelectorAll('.product-single__meta [data-bf-favorite]').forEach(function (button) {
      button.setAttribute('data-variant-id', variant.id);
      button.setAttribute('data-bf-favorite-sku', variant.sku || '');
      button.setAttribute('data-variant-title', variant.title || '');
      button.setAttribute('data-product-url', window.location.pathname + '?variant=' + encodeURIComponent(variant.id));
      if (variant.featured_image && variant.featured_image.src) {
        button.setAttribute('data-product-image', variant.featured_image.src);
      }
    });
  });
}());
